import { useCoachBilling } from "../context/CoachBillingContext.jsx";

export function useSubscription() {
  const {
    subscription,
    subscriptionLoading,
    subscriptionError,
    refetchSubscription,
  } = useCoachBilling();

  return {
    subscription,
    isLoading: subscriptionLoading,
    error: subscriptionError,
    refetch: refetchSubscription,
  };
}
